module.exports = __webpack_public_path__ + "static/media/SCR-A-078.ef3e503f.mp3";